/**
 * Avatares sem imagens.
 *
 * Enquanto não houver upload de avatar, uma pessoa é duas letras sobre uma
 * cor. A cor NÃO se guarda: deriva do id, logo é a mesma em todos os
 * clientes e em todas as sessões sem custar uma coluna na base de dados nem
 * um campo em cada evento do gateway.
 */

export function initials(name: string): string {
  return name.slice(0, 2).toUpperCase();
}

/** Cor estável derivada do id — evita guardar uma cor por utilizador. */
export function hueOf(id: string): number {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) % 360;
  return h;
}
